import { createFileRoute } from "@tanstack/react-router"
import { ShallowShelvesReport } from "@/features/reports/components/ShallowShelvesReport"
import {
  applyShallowShelvesDefaults,
  shallowShelvesQuery,
  ShallowShelvesSearchParams,
} from "@/features/reports/core/hooks/useShallowShelvesReport"

export const Route = createFileRoute("/(authenticated)/reports/shallow-shelves")({
  validateSearch: ShallowShelvesSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps: search }) => {
    void context.queryClient.ensureQueryData(
      shallowShelvesQuery(applyShallowShelvesDefaults(search)),
    )
  },
  component: ShallowShelvesReport,
})
